import './ServiceContactsSubpage.scss';

import { b2x } from '@b2x/react/src';

import { MiscellaneousContentType } from './contentTypes';

export type ServiceContactsSubpageProps = b2x.ServiceContactsSubpageProps;

export const ServiceContactsSubpage = (props: ServiceContactsSubpageProps) => {
  const miscellaneousContent = b2x.useContent<MiscellaneousContentType>('MISCELLANEOUS_CONTENT');
  return (
    <div className={'service-contact-page'}>
      <b2x.ServiceContactsSubpage {...props} contactUs={{ disableSatisfiedForm: true, showSatisfiedForm: false }} />
      <div className="miscellaneous-content pt-3">
        {b2x.formatHtml(miscellaneousContent?.body.contactUsPage?.notFoundLabel)}
        {/* {miscellaneousContent?.body.contactUsPage?.notFoundCta && (
          <b2x.CtaFromContent
            ctaProps={{
              button: {
                className: 'ps-1 fw-normal btn-link',
              },
            }}
            {...miscellaneousContent.body.contactUsPage.notFoundCta}
          />
        )} */}
      </div>
    </div>
  );
};
